function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledControlledInput } from "../../unstyled/input/UnstyledControlledInput";
import "./input.css";
const ControlledInput = ({
  label = null,
  name = null,
  type = "text",
  value = "",
  onChange = null,
  disabled = false,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledControlledInput, _extends({
    classPrepend: "styled",
    label: label,
    name: name,
    type: type,
    value: value,
    onChange: onChange,
    disabled: disabled
  }, rest));
};
export { ControlledInput };